import { motion } from "framer-motion";

// Signature on-load moment: masked line-by-line reveal
export const MaskedLines = ({ lines, baseDelay = 0, stagger = 0.12, className = "" }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} style={{ overflow: "hidden" }}>
        <motion.div
          initial={{ y: "100%", opacity: 1 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{
            duration: 1,
            delay: baseDelay + i * stagger,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);
